export default "__VITE_ASSET__IE3OSjxj__"